import { render, staticRenderFns } from "./WardrobePosition.vue?vue&type=template&id=60d3e05b&scoped=true&"
import script from "./WardrobePosition.vue?vue&type=script&lang=js&"
export * from "./WardrobePosition.vue?vue&type=script&lang=js&"
import style0 from "./WardrobePosition.vue?vue&type=style&index=0&id=60d3e05b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d3e05b",
  null
  
)

export default component.exports